import RegisterForm from 'components/Forms/RegisterForm/RegisterForm'

import { Login, MainPage, StatementPage, TasksPage } from 'pages'

import ChatPageContainer from 'pages/ChatPage/ChatPageContainer'

import StatementInfo from 'pages/StatementPage/components/StatementTable/StatementInfo/StatementInfo'

import TaskItemInfo from 'pages/TasksPage/components/TaskItem/TaskItemInfo/TaskItemInfo'

import TaskTree from 'hooks/TaskTree/TaskTree'

import QuizForm from 'components/Forms/QuizForm/QuizForm'
import StructureForm from 'components/Forms/StructureForm/StructureForm'

import CalendarPage from 'pages/CalendarPage/CalendarPage'
import AllStatisticPage from 'pages/StatisticPage/AllStatisticPage'
import StatisticPage from 'pages/StatisticPage/StatisticPage'
import StructureInfo from 'pages/StructurePage/components/StructureInfo'
import StructurePage from 'pages/StructurePage/StructurePage'

import { ArchivePage, ArchiveDetail } from 'pages/ArchivePage'

import Europass from 'pages/ProfilePage/Europass/Europass'
import FinalEuropass from 'pages/ProfilePage/Europass/FinalEuropass'
import PersonalCard from 'pages/ProfilePage/PersonalCard/PersonalCard'

import EuropassEn from 'pages/ProfilePage/Europass/EuropassEn/EuropassEn'
import FinalEuropassEn from 'pages/ProfilePage/Europass/EuropassEn/FinalEuropassEn'
import EuropassKy from 'pages/ProfilePage/Europass/EuropassKy/EuropassKy'
import FinalEuropassKy from 'pages/ProfilePage/Europass/EuropassKy/FinalEuropassKy'

import AdminPage from 'pages/AdminPage/AdminPage'

import ReportCard from 'pages/ReportCard/ReportCard'
import NotesPage from 'pages/NotesPage/NotesPage'

import TestPage from 'pages/TestPage/TestPage'
import TestContent from 'pages/TestPage/components/components/TestContent'
import PartWorkUsed from 'pages/TestPage/components/usedcomponents/PartWorkUsed'
import PartWorkUsedAllUser from 'pages/TestPage/components/usedcomponents/PartWorkUsedAllUser'
import SurveyPage from 'pages/SurveyPage/SurveyPage'
import SurveyContent from 'pages/SurveyPage/components/components/SurveyContent'
import PartSurveyUsed from 'pages/SurveyPage/components/usedcomponents/PartSurveyUsed'
import PartSurveyUsedAllUser from 'pages/SurveyPage/components/usedcomponents/PartSurveyUsedAllUser'

import AccountingPage from 'pages/AccountingPage/AccountingPage'
import AccountingDataPage from 'pages/AccountingPage/AccountingDataPage'

import StudentDashboard from 'pages/StudentDashboard/StudentDashboard'
import ApplicantHome from 'pages/ApplicantHome/ApplicantHome'
import TeacherDashboard from 'pages/TeacherDashboard/TeacherDashboard'
import SchedulePage from 'pages/SchedulePage/SchedulePage'
import ScheduleBuilderPage from 'pages/SchedulePage/ScheduleBuilderPage'
import SyllabusViewPage from 'pages/SyllabusViewPage/SyllabusViewPage'
import JournalPage from 'pages/JournalPage/JournalPage'
import GradebookPage from 'pages/GradebookPage/GradebookPage'
import AssignmentsPage from 'pages/AssignmentsPage/AssignmentsPage'
import StatementsPage from 'pages/StatementsPage/StatementsPage'

import AdminFullPage from 'pages/AdminFullPage/AdminFullPage'
import ProtectedRoute from 'components/Auth/ProtectedRoute'
import AccountLockedPage from 'pages/Auth/AccountLockedPage'
import TwoFactorSetupPage from 'pages/Auth/TwoFactorSetupPage'
import RoleHomeRedirect from 'pages/Auth/RoleHomeRedirect'

import OrdersPage from 'pages/OrdersPage/OrdersPage'
import GroupsPage from 'pages/GroupsPage/GroupsPage'

import LibraryPage from 'pages/LibraryPage/LibraryPage'
import DormPage from 'pages/DormPage/DormPage'
import PracticePage from 'pages/PracticePage/PracticePage'
import DiplomaPage from 'pages/DiplomaPage/DiplomaPage'
import TestTakingPage from 'pages/TestPage/TestTakingPage'
import TestBuilderPage from 'pages/TestPage/TestBuilderPage'
import QuestionBankPage from 'pages/TestPage/QuestionBankPage'
import DeanDashboard from 'pages/DeanDashboard/DeanDashboard'
import SubjectPage from 'pages/SubjectPage/SubjectPage'

import EmployeeWizardPage from 'pages/HR/EmployeeWizardPage'
import EmployeeCardPage from 'pages/HR/EmployeeCardPage'
import StudentLifecyclePage from 'pages/HR/StudentLifecyclePage'

import SyllabusBuilderPage from 'pages/SyllabusBuilder/SyllabusBuilderPage'
import SyllabusDiffPage from 'pages/SyllabusBuilder/SyllabusDiffPage'
import SyllabusApprovalPage from 'pages/SyllabusBuilder/SyllabusApprovalPage'

import ExamSessionsPage from 'pages/Sessions/ExamSessionsPage'
import LessonRescheduleModal from 'pages/SchedulePage/LessonRescheduleModal'
import ScheduleImportPage from 'pages/SchedulePage/ScheduleImportPage'

import AbsenceJustificationPage from 'pages/Journal/AbsenceJustificationPage'
import CuratorDrilldownPage from 'pages/DeanDashboard/CuratorDrilldownPage'

import ReportsPage from 'pages/Reports/ReportsPage'
import Form1NKPage from 'pages/Reports/Form1NKPage'
import ContingentReportPage from 'pages/Reports/ContingentReportPage'
import AccreditationReportPage from 'pages/Reports/AccreditationReportPage'

import DistanceLearningPage from 'pages/DistanceLearning/DistanceLearningPage'
import VideoLecturesPage from 'pages/DistanceLearning/VideoLecturesPage'
import VirtualClassroomPage from 'pages/DistanceLearning/VirtualClassroomPage'

import PostgradPage from 'pages/Postgrad/PostgradPage'
import ForeignStudentsPage from 'pages/ForeignStudents/ForeignStudentsPage'
import MilitaryStudentPage from 'pages/Military/MilitaryStudentPage'
import DpoPage from 'pages/Dpo/DpoPage'
import StudentLifePage from 'pages/StudentLife/StudentLifePage'
import SciencePage from 'pages/Science/SciencePage'
import CareerPage from 'pages/Career/CareerPage'
import PlagiarismPage from 'pages/Plagiarism/PlagiarismPage'
import OcrSearchPage from 'pages/Archive/OcrSearchPage'
import OrderArchiveLinkPage from 'pages/Archive/OrderArchiveLinkPage'

import HelpPage from 'pages/Help/HelpPage'
import ApiDocsPage from 'pages/Help/ApiDocsPage'

import IntegrationsPage from 'pages/Integrations/IntegrationsPage'
import ServicesPage from 'pages/Services/ServicesPage'

import { Navigate } from 'react-router-dom'

const ADMIN_ROLES = ['rectorate', 'sysadmin', 'methodist', 'dean', 'head_of_department', 'hr_students', 'hr_employees', 'accountant', 'archivist']
const HR_STUDENTS = ['hr_students', 'methodist', 'dean', 'rectorate', 'sysadmin']
const HR_EMPLOYEES = ['hr_employees', 'rectorate', 'sysadmin']
const METHODIST = ['methodist', 'dean', 'head_of_department', 'rectorate', 'sysadmin']
const DEAN = ['dean', 'rectorate', 'sysadmin']
// Wave 4: ролевые группы для приватных страниц.
const TEACHER_HOME_ROLES = ['teacher', 'dean', 'methodist', 'curator', 'head_of_department']
const JOURNAL_ROLES = ['teacher', 'dean', 'curator', 'methodist', 'head_of_department', 'student']
const GRADEBOOK_ROLES = ['teacher', 'dean', 'methodist', 'student', 'curator', 'parent', 'head_of_department']
const DORM_ROLES = ['dorm_staff', 'hr_students', 'rectorate', 'sysadmin', 'accountant', 'student']
const PRACTICE_ROLES = ['student', 'teacher', 'methodist', 'dean', 'head_of_department']
const DIPLOMA_ROLES = ['student', 'teacher', 'dean', 'methodist', 'head_of_department']
const DISTANCE_ROLES = ['student', 'teacher', 'methodist', 'dean']
const DPO_ROLES = ['dpo_student', 'methodist', 'rectorate', 'sysadmin']
const STUDENT_LIFE_ROLES = ['student', 'curator', 'teacher', 'dean']
const SCIENCE_ROLES = ['teacher', 'methodist', 'rectorate', 'sysadmin', 'dean']
const CAREER_ROLES = ['student', 'teacher', 'rectorate', 'sysadmin']
const WORKLOAD_ROLES = ['teacher', 'dean', 'head_of_department', 'methodist']
const MY_DISCIPLINES_ROLES = ['teacher']
const TAKE_TEST_ROLES = ['student']
const EMPLOYEE_CARD_ROLES = ['hr_employees', 'rectorate', 'sysadmin', 'dean', 'head_of_department']
const POSTGRAD_ROLES = ['postgrad', 'methodist', 'dean', 'rectorate', 'sysadmin']
const STUDENT_HOME_ROLES = ['student', 'parent', 'foreign_student', 'postgrad', 'dpo_student']

const wrap = (el, roles) => roles ? <ProtectedRoute requireRoles={roles}>{el}</ProtectedRoute> : <ProtectedRoute>{el}</ProtectedRoute>
const bare = (el) => <ProtectedRoute bare>{el}</ProtectedRoute>

export const routes = [
  { path: '/', component: <Login /> },
  { path: '/login', component: <Login /> },
  { path: '/login/', component: <Login /> },
  // FIX (Промежуток): deep-link на восстановление пароля/ПИНа.
  // LoginForm читает pathname / ?recover=password|pin и сразу разворачивает форму.
  { path: '/recover-password/', component: <Login /> },
  { path: '/recover-pin/', component: <Login /> },
  { path: '/account-locked/', component: <AccountLockedPage /> },
  { path: '/2fa-setup/', component: bare(<TwoFactorSetupPage />) },
  { path: '/post-login/', component: bare(<RoleHomeRedirect />) },

  { path: '/home/', component: wrap(<MainPage />) },

  { path: '/tasks/', component: wrap(<TasksPage />) },
  { path: '/task/', component: wrap(<TaskItemInfo isSubTask={false} />) },
  { path: '/subtask/', component: wrap(<TaskItemInfo isSubTask={true} />) },
  { path: '/statements/', component: wrap(<StatementPage />) },
  { path: '/statement/', component: wrap(<StatementInfo />) },
  { path: '/chats/', component: wrap(<ChatPageContainer />) },
  { path: '/chats/:id/', component: wrap(<ChatPageContainer />) },
  { path: '/register_person/', component: wrap(<RegisterForm />, HR_EMPLOYEES) },
  { path: '/statistic/', component: wrap(<StatisticPage />) },
  { path: '/all-statistic/', component: wrap(<AllStatisticPage />, ADMIN_ROLES) },
  { path: '/task-tree/', component: wrap(<TaskTree />) },
  { path: '/structure/', component: wrap(<StructurePage />) },
  { path: '/structure-sheme/:id/', component: wrap(<StructureInfo />) },
  { path: '/add-structure/', component: wrap(<StructureForm />, ADMIN_ROLES) },
  { path: '/answer-quiz/', component: wrap(<QuizForm />) },
  { path: '/calendar/', component: wrap(<CalendarPage />) },
  { path: '/report-card/', component: wrap(<ReportCard />) },
  { path: '/notes/', component: wrap(<NotesPage />) },

  { path: '/personalcard/', component: wrap(<PersonalCard />) },
  { path: '/europass/', component: wrap(<Europass />) },
  { path: '/finaleuro/', component: wrap(<FinalEuropass />) },
  { path: '/europassen/', component: wrap(<EuropassEn />) },
  { path: '/finaleuropassen/', component: wrap(<FinalEuropassEn />) },
  { path: '/europassky/', component: wrap(<EuropassKy />) },
  { path: '/finaleuropassky/', component: wrap(<FinalEuropassKy />) },
  { path: '/admin_organizations/', component: wrap(<AdminPage />, ADMIN_ROLES) },

  { path: '/test/:id', component: wrap(<PartWorkUsedAllUser />) },
  { path: '/tests/', component: wrap(<TestPage />) },
  { path: '/worktest/', component: wrap(<TestContent />) },
  { path: '/useworktest/', component: wrap(<PartWorkUsed />) },
  { path: '/test-builder/', component: wrap(<TestBuilderPage />, ['teacher', 'methodist', 'head_of_department', 'sysadmin']) },
  { path: '/test-builder/:id', component: wrap(<TestBuilderPage />, ['teacher', 'methodist', 'head_of_department', 'sysadmin']) },
  { path: '/question-bank/', component: wrap(<QuestionBankPage />, ['teacher', 'methodist', 'head_of_department', 'sysadmin']) },

  { path: '/surveys/', component: wrap(<SurveyPage />) },
  { path: '/survey/', component: wrap(<SurveyContent />) },
  { path: '/survey/:id', component: wrap(<PartSurveyUsedAllUser />) },
  { path: '/usesurvey/', component: wrap(<PartSurveyUsed />) },

  { path: '/accounting/', component: wrap(<AccountingPage />, ['accountant', 'rectorate', 'sysadmin']) },
  { path: '/accounting-info/', component: wrap(<AccountingDataPage />, ['accountant', 'rectorate', 'sysadmin']) },

  { path: '/archive/', component: wrap(<ArchivePage />, ['archivist', 'rectorate', 'sysadmin', 'hr_students', 'hr_employees']) },
  { path: '/archive/:archiveType/', component: wrap(<ArchiveDetail />, ['archivist', 'rectorate', 'sysadmin', 'hr_students', 'hr_employees']) },
  { path: '/archive/ocr-search/', component: wrap(<OcrSearchPage />, ['archivist', 'rectorate', 'sysadmin']) },
  { path: '/archive/order-link/', component: wrap(<OrderArchiveLinkPage />, ['archivist', 'rectorate', 'sysadmin']) },

  { path: '/student-home/', component: wrap(<StudentDashboard />, STUDENT_HOME_ROLES) },
  { path: '/teacher-home/', component: wrap(<TeacherDashboard />, TEACHER_HOME_ROLES) },
  // P1-A1: домашняя для роли applicant. Только сама роль; админам её показывать
  // нет смысла — пусть идут в /admin/admission/.
  { path: '/applicant-home/', component: wrap(<ApplicantHome />, ['applicant']) },
  { path: '/schedule/', component: wrap(<SchedulePage />) },
  { path: '/schedule-builder/', component: wrap(<ScheduleBuilderPage />, ADMIN_ROLES) },
  { path: '/schedule-import/', component: wrap(<ScheduleImportPage />, METHODIST) },
  { path: '/lesson-reschedule/', component: wrap(<LessonRescheduleModal />, ADMIN_ROLES) },
  { path: '/sessions/', component: wrap(<ExamSessionsPage />, METHODIST) },

  // Wave 4: дубль `/syllabus-view/` редиректим на `/my-syllabus/` (используется в StudentDashboard).
  { path: '/syllabus-view/', component: <Navigate to="/my-syllabus/" replace /> },
  { path: '/my-syllabus/', component: wrap(<SyllabusViewPage />, ['student', 'parent', 'teacher', 'curator']) },
  { path: '/syllabuses/', component: wrap(<SyllabusViewPage />, ADMIN_ROLES) },
  { path: '/syllabus-builder/', component: wrap(<SyllabusBuilderPage />, METHODIST) },
  { path: '/syllabus-builder/:id', component: wrap(<SyllabusBuilderPage />, METHODIST) },
  { path: '/syllabus-diff/', component: wrap(<SyllabusDiffPage />, METHODIST) },
  { path: '/syllabus-approval/', component: wrap(<SyllabusApprovalPage />, ['dean', 'rectorate', 'sysadmin']) },

  { path: '/journal/', component: wrap(<JournalPage />, JOURNAL_ROLES) },
  { path: '/gradebook/', component: wrap(<GradebookPage />, GRADEBOOK_ROLES) },
  { path: '/absence-justification/', component: wrap(<AbsenceJustificationPage />, ['student', 'curator', 'dean', 'methodist', 'head_of_department']) },
  { path: '/curator-drilldown/', component: wrap(<CuratorDrilldownPage />, ['dean', 'rectorate', 'sysadmin', 'methodist', 'head_of_department']) },
  { path: '/assignments-list/', component: wrap(<AssignmentsPage />, ['student', 'teacher', 'methodist', 'dean', 'curator', 'head_of_department']) },
  // Wave 4: `/statements-list/` устарел (в TeacherDashboard) → редиректим на `/teacher-statements/`.
  { path: '/statements-list/', component: <Navigate to="/teacher-statements/" replace /> },
  { path: '/teacher-statements/', component: wrap(<StatementsPage />, ['teacher', 'methodist', 'dean', 'head_of_department']) },

  { path: '/orders/', component: wrap(<OrdersPage />, ['hr_students', 'hr_employees', 'methodist', 'dean', 'rectorate', 'sysadmin']) },
  { path: '/groups/', component: wrap(<GroupsPage />, METHODIST) },
  { path: '/students-list/', component: wrap(<AdminFullPage initialTab="students" />, HR_STUDENTS) },
  { path: '/employees/', component: wrap(<AdminFullPage initialTab="employees" />, HR_EMPLOYEES) },
  { path: '/admission/', component: wrap(<AdminFullPage initialTab="enroll" />, ['hr_students', 'rectorate', 'sysadmin']) },
  { path: '/transfers/', component: wrap(<AdminFullPage initialTab="students" />, HR_STUDENTS) },
  { path: '/employee-wizard/', component: wrap(<EmployeeWizardPage />, HR_EMPLOYEES) },
  { path: '/employee-card/:id', component: wrap(<EmployeeCardPage />, EMPLOYEE_CARD_ROLES) },
  { path: '/student-lifecycle/:id', component: wrap(<StudentLifecyclePage />, HR_STUDENTS) },

  { path: '/library/', component: wrap(<LibraryPage />) },
  { path: '/dorm/', component: wrap(<DormPage />, DORM_ROLES) },
  { path: '/practice/', component: wrap(<PracticePage />, PRACTICE_ROLES) },
  { path: '/diploma/', component: wrap(<DiplomaPage />, DIPLOMA_ROLES) },
  { path: '/take-test/:id', component: wrap(<TestTakingPage />, TAKE_TEST_ROLES) },
  { path: '/dean-dashboard/', component: wrap(<DeanDashboard />, DEAN) },
  { path: '/subject/:id/', component: wrap(<SubjectPage />) },

  { path: '/reports/', component: wrap(<ReportsPage />, METHODIST) },
  { path: '/reports/form-1nk/', component: wrap(<Form1NKPage />, METHODIST) },
  { path: '/reports/contingent/', component: wrap(<ContingentReportPage />, METHODIST) },
  { path: '/reports/accreditation/', component: wrap(<AccreditationReportPage />, ['rectorate', 'sysadmin', 'dean']) },

  { path: '/distance/', component: wrap(<DistanceLearningPage />, DISTANCE_ROLES) },
  { path: '/distance/lectures/', component: wrap(<VideoLecturesPage />, DISTANCE_ROLES) },
  { path: '/distance/virtual/', component: wrap(<VirtualClassroomPage />, DISTANCE_ROLES) },
  { path: '/distance/virtual/:id', component: wrap(<VirtualClassroomPage />, DISTANCE_ROLES) },

  { path: '/postgrad/', component: wrap(<PostgradPage />, POSTGRAD_ROLES) },
  { path: '/foreign-students/', component: wrap(<ForeignStudentsPage />, HR_STUDENTS) },
  { path: '/military-students/', component: wrap(<MilitaryStudentPage />, HR_STUDENTS) },
  { path: '/dpo/', component: wrap(<DpoPage />, DPO_ROLES) },
  { path: '/student-life/', component: wrap(<StudentLifePage />, STUDENT_LIFE_ROLES) },
  { path: '/science/', component: wrap(<SciencePage />, SCIENCE_ROLES) },
  { path: '/career/', component: wrap(<CareerPage />, CAREER_ROLES) },
  { path: '/plagiarism/', component: wrap(<PlagiarismPage />, ['teacher', 'methodist', 'dean', 'rectorate', 'sysadmin']) },

  { path: '/help/', component: wrap(<HelpPage />) },
  { path: '/help/api/', component: wrap(<ApiDocsPage />, ['sysadmin']) },
  { path: '/admin/integrations/', component: wrap(<IntegrationsPage />, ['sysadmin', 'rectorate']) },
  // Промежуток-101%: каталог сервисов платформы — только для суперадмина и ректората.
  { path: '/admin/services/', component: wrap(<ServicesPage />, ['sysadmin', 'rectorate']) },

  { path: '/create-statement/', component: wrap(<StatementPage />) },
  { path: '/statement-history/', component: wrap(<StatementPage />) },
  { path: '/workload/', component: wrap(<TeacherDashboard />, WORKLOAD_ROLES) },
  { path: '/my-disciplines/', component: wrap(<JournalPage />, MY_DISCIPLINES_ROLES) },
  // Wave 4: alias `/admin-full/` → `/admin/` для обратной совместимости (см. ReportsPage).
  { path: '/admin-full/', component: <Navigate to="/admin/" replace /> },

  {
    path: '/admin/',
    component: <ProtectedRoute requireRoles={ADMIN_ROLES}><AdminFullPage /></ProtectedRoute>,
  },
]
